// Definiciones de flujo (representativas, sin ejecución real todavía).
// Cada flujo puede tener varias "acciones" (submenú tipo Workflow Builder).
// Cada nodo trae un "kind" que ServiceFlowCanvas traduce a color/estilo según el tema.
// "path" define el orden de recorrido usado para animar el botón Run.

export const opsGovernanceFlow = {
  key: 'ops-governance',
  label: 'Ops Governance',
  actions: [
    {
      key: 'general',
      label: 'Diagrama General',
      dotColor: '#00FF66',
      enabled: true,
      description: 'Ecosistema Centro de Operaciones · opscenter-mx / opscenter-backend-mx',
      nodes: [
        { id: 'usuario', kind: 'trigger', label: 'Usuario', sub: 'Acceso vía navegador', position: { x: 0, y: 160 } },
        { id: 'frontend', kind: 'process', label: 'Frontend (React)', sub: 'opscenter-mx', position: { x: 240, y: 160 } },
        { id: 'backend', kind: 'process', label: 'Backend (FastAPI)', sub: 'opscenter-backend-mx', position: { x: 480, y: 160 } },
        { id: 'security', kind: 'decision', label: 'Security Middleware', sub: 'Whitelist / rate limit', position: { x: 480, y: 0 } },
        { id: 'bigquery', kind: 'external', label: 'BigQuery', sub: 'Datos analíticos', position: { x: 740, y: 40 } },
        { id: 'gcs', kind: 'external', label: 'Cloud Storage', sub: 'Adjuntos / reportes', position: { x: 740, y: 160 } },
        { id: 'notion', kind: 'human', label: 'Notion API', sub: 'Seguimiento alianzas', position: { x: 740, y: 280 } },
      ],
      edges: [
        { id: 'e1', source: 'usuario', target: 'frontend' },
        { id: 'e2', source: 'frontend', target: 'backend', label: 'HTTP/JSON' },
        { id: 'e3', source: 'backend', target: 'security' },
        { id: 'e4', source: 'backend', target: 'bigquery' },
        { id: 'e5', source: 'backend', target: 'gcs' },
        { id: 'e6', source: 'backend', target: 'notion' },
      ],
      path: ['usuario', 'frontend', 'backend', 'security', 'bigquery', 'gcs', 'notion'],
    },
  ],
};

// ─── Healthcenter: arquitectura multicloud real (AWS + Azure + GCP + Huawei) ──
const healthcenterGeneral = {
  key: 'general',
  label: 'Diagrama General',
  dotColor: '#00FF66',
  enabled: true,
  description: 'Arquitectura completa · Django + Celery + Redis + 4 proveedores cloud',
  nodes: [
    { id: 'usuario', kind: 'trigger', label: 'Usuario', sub: 'Portal Healthcenter', position: { x: 0, y: 220 } },
    { id: 'gateway', kind: 'process', label: 'Nginx Gateway', sub: 'Reverse proxy :8081', position: { x: 240, y: 220 } },
    { id: 'web', kind: 'process', label: 'Django Web', sub: 'gunicorn (operations.wsgi)', position: { x: 480, y: 220 } },
    { id: 'redis', kind: 'decision', label: 'Redis', sub: 'Broker / result backend', position: { x: 720, y: 100 } },
    { id: 'celery', kind: 'process', label: 'Celery Worker', sub: 'Tareas asíncronas', position: { x: 720, y: 340 } },
    { id: 'aws', kind: 'external', label: 'AWS', sub: 'boto3 · CloudWatch / DRS', position: { x: 960, y: 0 } },
    { id: 'azure', kind: 'external', label: 'Azure', sub: 'Monitor · Elementia y clientes', position: { x: 960, y: 130 } },
    { id: 'gcp', kind: 'external', label: 'GCP', sub: 'Cloud Monitoring / Compute', position: { x: 960, y: 260 } },
    { id: 'huawei', kind: 'external', label: 'Huawei Cloud', sub: 'CloudEye', position: { x: 960, y: 390 } },
    { id: 'foundry', kind: 'human', label: 'AI Foundry', sub: 'Reporte ejecutivo con IA', position: { x: 1200, y: 340 } },
  ],
  edges: [
    { id: 'e1', source: 'usuario', target: 'gateway' },
    { id: 'e2', source: 'gateway', target: 'web', label: 'HTTP' },
    { id: 'e3', source: 'web', target: 'redis' },
    { id: 'e4', source: 'web', target: 'celery' },
    { id: 'e5', source: 'redis', target: 'celery' },
    { id: 'e6', source: 'celery', target: 'aws' },
    { id: 'e7', source: 'celery', target: 'azure' },
    { id: 'e8', source: 'celery', target: 'gcp' },
    { id: 'e9', source: 'celery', target: 'huawei' },
    { id: 'e10', source: 'celery', target: 'foundry' },
  ],
  path: ['usuario', 'gateway', 'web', 'redis', 'celery', 'aws', 'azure', 'gcp', 'huawei', 'foundry'],
};

const healthcenterReporteGlobal = {
  key: 'reporte-global',
  label: 'Reporte Global',
  dotColor: '#ff0080',
  enabled: true,
  description: 'Extracción multicloud → normalización → DOCX/PDF → reporte ejecutivo IA',
  nodes: [
    { id: 'trigger', kind: 'trigger', label: 'Solicitud Reporte', sub: 'Cliente + rango de fechas', position: { x: 0, y: 260 } },
    { id: 'cache', kind: 'decision', label: 'Cache de Métricas', sub: 'Azure Blob Storage', position: { x: 240, y: 260 } },
    { id: 'aws_c', kind: 'external', label: 'AWS', sub: 'CloudWatch / Backup / DRS', position: { x: 500, y: 0 } },
    { id: 'azure_c', kind: 'external', label: 'Azure', sub: 'Monitor / Elementia', position: { x: 500, y: 160 } },
    { id: 'gcp_c', kind: 'external', label: 'GCP', sub: 'Cloud Monitoring', position: { x: 500, y: 320 } },
    { id: 'huawei_c', kind: 'external', label: 'Huawei', sub: 'CloudEye', position: { x: 500, y: 480 } },
    { id: 'normaliza', kind: 'process', label: 'Normalización', sub: 'Métricas + KPIs (Python)', position: { x: 760, y: 240 } },
    { id: 'finops', kind: 'external', label: 'FinOps', sub: 'Costos Apptio', position: { x: 1000, y: 0 } },
    { id: 'secops', kind: 'external', label: 'Seguridad', sub: 'Prowler', position: { x: 1000, y: 150 } },
    { id: 'tickets', kind: 'external', label: 'Tickets', sub: 'Mesa de ayuda', position: { x: 1000, y: 300 } },
    { id: 'diagramas', kind: 'process', label: 'Diagramas', sub: 'Topología del cliente', position: { x: 1000, y: 450 } },
    { id: 'docx', kind: 'process', label: 'Generar DOCX', sub: 'Reporte tradicional', position: { x: 1260, y: 220 } },
    { id: 'pdf', kind: 'process', label: 'Convertir a PDF', sub: 'LibreOffice headless', position: { x: 1500, y: 220 } },
    { id: 'foundry', kind: 'human', label: 'Reporte Ejecutivo', sub: 'Microsoft Foundry (IA)', position: { x: 1740, y: 100 } },
    { id: 'gcs', kind: 'external', label: 'Guardar en GCS', sub: 'Bucket reportes/executive', position: { x: 1740, y: 320 } },
  ],
  edges: [
    { id: 'e1', source: 'trigger', target: 'cache' },
    { id: 'e2', source: 'cache', target: 'aws_c' },
    { id: 'e3', source: 'cache', target: 'azure_c' },
    { id: 'e4', source: 'cache', target: 'gcp_c' },
    { id: 'e5', source: 'cache', target: 'huawei_c' },
    { id: 'e6', source: 'aws_c', target: 'normaliza' },
    { id: 'e7', source: 'azure_c', target: 'normaliza' },
    { id: 'e8', source: 'gcp_c', target: 'normaliza' },
    { id: 'e9', source: 'huawei_c', target: 'normaliza' },
    { id: 'e10', source: 'normaliza', target: 'finops' },
    { id: 'e11', source: 'normaliza', target: 'secops' },
    { id: 'e12', source: 'normaliza', target: 'tickets' },
    { id: 'e13', source: 'normaliza', target: 'diagramas' },
    { id: 'e14', source: 'finops', target: 'docx' },
    { id: 'e15', source: 'secops', target: 'docx' },
    { id: 'e16', source: 'tickets', target: 'docx' },
    { id: 'e17', source: 'diagramas', target: 'docx' },
    { id: 'e18', source: 'docx', target: 'pdf' },
    { id: 'e19', source: 'pdf', target: 'foundry' },
    { id: 'e20', source: 'pdf', target: 'gcs' },
    { id: 'e21', source: 'foundry', target: 'gcs' },
  ],
  path: [
    'trigger', 'cache', 'aws_c', 'azure_c', 'gcp_c', 'huawei_c', 'normaliza',
    'finops', 'secops', 'tickets', 'diagramas', 'docx', 'pdf', 'foundry', 'gcs',
  ],
};

export const healthcenterFlow = {
  key: 'healthcenter',
  label: 'Healthcenter',
  actions: [
    healthcenterGeneral,
    healthcenterReporteGlobal,
    { key: 'auditoria-seguridad', label: 'Auditoría de Seguridad', dotColor: '#ff9b00', enabled: false, description: 'Próximamente' },
    { key: 'sync-tickets', label: 'Sync de Tickets', dotColor: '#04d9ff', enabled: false, description: 'Próximamente' },
  ],
};

export const ALL_FLOWS = [opsGovernanceFlow, healthcenterFlow];
